var exports = {
  "E": "Text__dO62_n",
};

module.exports = exports;
